<script>
import Layout from '@layouts/main';
import CountryForm from '@views/countries/form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEdit';

export default {
  name: 'CountryEdit',
  components: {
    Layout,
    CountryForm,
  },
  mixins: [beforeLeaveAfterEdit],
  page() {
    return {
      title: `${this.$t('titles.edit_country')} #${this.$route.params.id}`,
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.countries'),
          to: { name: 'countries.index' },
        },
        {
          text: `${this.$t('titles.edit_country')} #${this.$route.params.id}`,
          active: true,
        },
      ],
    };
  },
  methods: {
    update() {
      this.setUnchanged();
      this.$router.push({
        name: 'countries.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.edit_country')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <CountryForm :loaded-id="$route.params.id" @submitted="update" @entity-changed="initBeforeLeave" />
    </b-card>
  </Layout>
</template>
